import { render, staticRenderFns } from "./crown.vue?vue&type=template&id=0b9d8f31&scoped=true&"
var script = {}
import style0 from "./crown.vue?vue&type=style&index=0&id=0b9d8f31&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9d8f31",
  null
  
)

export default component.exports